const themeColor = "rgba(203, 46, 186, 1)";
const themeColorNew = "rgba(137, 31, 122, 1)";
const themeColorBlack = "rgba(21, 0, 39, 1)";
const themeColorBorder = "rgba(74, 30, 71, 0.70)";
const themeColorLight = "rgba(74, 30, 71, 0.50)";
const themeColorBg = "rgba(245, 245, 245, 1)";
const chatBotBg = "rgba(74, 30, 71, 0.05)";
const themeColorDark = "rgba(74, 30, 71, 1)";
const bgColorSelect = "rgba(0, 0, 0, 0.05)";
const cardBgColor = "rgba(250,248,248,1)";
const XebiaPurple = "rgba(21,0,39,1)";
const XebiaPink = "rgba(227,49,208,0.9)";
const white = "rgba(255, 255, 255, 1)";
const black = "rgba(0, 0, 0, 1)";
const darkGrey = "#3b3b3b";
const midGrey = "#6c6c6c";
const grey50 = "rgba(120, 120, 125, 1)";
const lightGrey = "#cccccc";
const AgentsAlertColor = "rgba(6, 169, 156, 1)";
const AgentsAlertBgColor = "#e5fafa";
const wiseSageColor = "#06A99C";
const wiseSageBgColor = "#E7F7F6";

export {
  themeColor,
  themeColorNew,
  AgentsAlertColor,
  AgentsAlertBgColor,
  wiseSageColor,
  wiseSageBgColor,
  themeColorBlack,
  darkGrey,
  midGrey,
  lightGrey,
  grey50,
  white,
  black,
  chatBotBg,
  themeColorDark,
  themeColorBorder,
  themeColorLight,
  themeColorBg,
  cardBgColor,
  XebiaPurple,
  XebiaPink,
  bgColorSelect
};
